/**
 * EWA Favorites — Faz 1 (localStorage)
 */
(function () {
  const STORAGE_KEY = 'ewa_favorites_v1';
  const MAX_ITEMS = 50;
  const strings = window.ewaFavoritesStrings || {};

  function propertiesHash(properties) {
    if (!properties || typeof properties !== 'object') return '';
    const keys = Object.keys(properties).sort();
    if (!keys.length) return '';
    return keys.map((key) => `${key}:${properties[key]}`).join('|');
  }

  function itemKey(item) {
    return `${item.variantId}::${item.propertiesHash || propertiesHash(item.properties)}`;
  }

  function readStore() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { version: 1, items: [] };
      const parsed = JSON.parse(raw);
      if (!parsed || parsed.version !== 1 || !Array.isArray(parsed.items)) {
        return { version: 1, items: [] };
      }
      return parsed;
    } catch {
      return { version: 1, items: [] };
    }
  }

  function writeStore(store) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  }

  function normalizeItem(item) {
    const properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
    const hash = item.propertiesHash || propertiesHash(properties);
    return {
      productId: String(item.productId),
      productHandle: String(item.productHandle),
      variantId: String(item.variantId),
      properties,
      propertiesHash: hash,
      addedAt: item.addedAt || Date.now(),
    };
  }

  let toastTimer = null;

  function showToast(action) {
    let toast = document.getElementById('ewa-favorites-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ewa-favorites-toast';
      toast.className = 'ewa-favorites-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    const message =
      action === 'add'
        ? strings.savedToast || 'Saved to your favorites'
        : strings.removedToast || 'Removed from favorites';

    const viewLink =
      action === 'add'
        ? `<a class="ewa-favorites-toast__link aycan-slide-underline" href="${strings.favoritesUrl || '/pages/favorites'}">${strings.view || 'View'}</a>`
        : '';

    toast.innerHTML = `<span class="ewa-favorites-toast__text">${message}</span>${viewLink}`;
    toast.hidden = false;

    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.hidden = true;
    }, 3500);
  }

  function updateHeaderCount(count) {
    const pageCount = document.querySelector('[data-ewa-favorites-page-count]');
    if (pageCount) {
      if (count <= 0) {
        pageCount.hidden = true;
      } else {
        pageCount.hidden = false;
        pageCount.textContent = (strings.countTemplate || '{{count}} saved').replace('{{count}}', String(count));
      }
    }
  }

  function dispatchUpdated(detail) {
    document.dispatchEvent(new CustomEvent('ewa:favorites-updated', { detail }));
    updateHeaderCount(detail.count);
  }

  const EwaFavorites = {
    getAll() {
      return readStore().items.map(normalizeItem);
    },

    count() {
      return readStore().items.length;
    },

    has(variantId, propertiesHashArg = '') {
      const key = `${variantId}::${propertiesHashArg || ''}`;
      return readStore().items.some((item) => itemKey(normalizeItem(item)) === key);
    },

    add(item) {
      const store = readStore();
      const normalized = normalizeItem(item);
      const key = itemKey(normalized);

      if (store.items.some((existing) => itemKey(normalizeItem(existing)) === key)) {
        return false;
      }

      if (store.items.length >= MAX_ITEMS) {
        store.items.pop();
      }

      store.items.unshift(normalized);
      writeStore(store);
      dispatchUpdated({ count: store.items.length, action: 'add', item: normalized });
      showToast('add');
      this.syncDom();
      return true;
    },

    remove(variantId, propertiesHashArg = '') {
      const store = readStore();
      const key = `${variantId}::${propertiesHashArg || ''}`;
      const idx = store.items.findIndex((item) => itemKey(normalizeItem(item)) === key);
      if (idx === -1) return false;

      const [removed] = store.items.splice(idx, 1);
      writeStore(store);
      dispatchUpdated({ count: store.items.length, action: 'remove', item: normalizeItem(removed) });
      showToast('remove');
      this.syncDom();
      return true;
    },

    toggle(item) {
      const normalized = normalizeItem(item);
      const key = itemKey(normalized);
      if (readStore().items.some((existing) => itemKey(normalizeItem(existing)) === key)) {
        return !this.remove(normalized.variantId, normalized.propertiesHash);
      }
      return this.add(normalized);
    },

    syncDom() {
      const items = this.getAll();
      const savedKeys = new Set(items.map(itemKey));

      document.querySelectorAll('[data-ewa-favorite]').forEach((btn) => {
        const variantId = btn.getAttribute('data-variant-id');
        const hash = btn.getAttribute('data-properties-hash') || '';
        const productId = btn.getAttribute('data-product-id');
        let saved = savedKeys.has(`${variantId}::${hash}`);

        if (btn.getAttribute('data-requires-coaster-pick') === 'true') {
          saved = items.some((item) => String(item.productId) === String(productId));
        }

        btn.classList.toggle('is-saved', saved);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      });
    },
  };

  window.EwaFavorites = EwaFavorites;

  /* ── Coaster mini-picker modal ───────────────────────── */
  const coasterState = {
    product: null,
    grid1: [],
    grid2: [],
    pendingBtn: null,
  };

  function ensureCoasterCss() {
    if (document.querySelector('link[data-ewa-coaster-css]')) return;
    const href = window.ewaFavoritesAssets?.coasterCss;
    if (!href) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.ewaCoasterCss = 'true';
    document.head.appendChild(link);
  }

  function getCoasterModal() {
    return document.getElementById('ewa-favorites-coaster-modal');
  }

  function closeCoasterModal() {
    const modal = getCoasterModal();
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
    coasterState.product = null;
    coasterState.grid1 = [];
    coasterState.grid2 = [];
    coasterState.pendingBtn = null;
  }

  function renderCoasterGrids(product) {
    const modal = getCoasterModal();
    if (!modal) return;

    const grid1El = modal.querySelector('[data-ewa-coaster-grid="1"]');
    const grid2El = modal.querySelector('[data-ewa-coaster-grid="2"]');
    if (!grid1El || !grid2El) return;

    const swatchHtml = (variant, grid) => {
      const code = variant.title || variant.option1 || variant.name;
      const img = variant.featured_image?.src || '';
      const disabled = !variant.available ? 'disabled' : '';
      const itemAttrs = `data-grid="${grid}" data-variant-id="${variant.id}" data-code="${escapeHtml(code)}"`;

      if (img) {
        return `
        <div class="aycan-swatch-item" ${itemAttrs}>
          <button class="aycan-swatch__btn aycan-swatch__btn--image" type="button" aria-label="${escapeHtml(code)}" aria-pressed="false" ${disabled}>
            <span class="aycan-swatch__figure">
              <img src="${img}" loading="lazy" width="80" height="80" alt="${escapeHtml(code)}">
            </span>
          </button>
        </div>`;
      }

      return `
        <div class="aycan-swatch-item" ${itemAttrs}>
          <button class="aycan-swatch__btn" type="button" aria-label="${escapeHtml(code)}" aria-pressed="false" ${disabled}>
            ${escapeHtml(code)}
          </button>
        </div>`;
    };

    grid1El.innerHTML = product.variants.map((v) => swatchHtml(v, '1')).join('');
    grid2El.innerHTML = product.variants.map((v) => swatchHtml(v, '2')).join('');
    modal.querySelector('[data-ewa-coaster-validation]').hidden = true;
    modal.querySelector('[data-ewa-coaster-save]').disabled = true;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function validateCoasterModal() {
    const modal = getCoasterModal();
    if (!modal) return;
    const g1 = coasterState.grid1.length;
    const g2 = coasterState.grid2.length;
    const valid = g1 > 0 && g1 === g2;
    const validation = modal.querySelector('[data-ewa-coaster-validation]');
    const saveBtn = modal.querySelector('[data-ewa-coaster-save]');

    if (validation) {
      if (g1 === 0 && g2 === 0) {
        validation.hidden = true;
      } else if (!valid) {
        validation.textContent = `Coaster 1: ${g1} selected, Coaster 2: ${g2} selected — counts must match.`;
        validation.hidden = false;
      } else {
        validation.hidden = true;
      }
    }

    if (saveBtn) saveBtn.disabled = !valid;
  }

  function toggleCoasterSwatch(item) {
    const grid = item.dataset.grid;
    const code = item.dataset.code;
    const arr = grid === '1' ? coasterState.grid1 : coasterState.grid2;
    const idx = arr.findIndex((x) => x.code === code);
    const selected = idx === -1;

    item.classList.toggle('aycan-swatch-item--selected', selected);
    item.querySelector('.aycan-swatch__btn')?.setAttribute('aria-pressed', String(selected));

    if (selected) {
      arr.push({ code, variantId: item.dataset.variantId });
    } else {
      arr.splice(idx, 1);
    }

    validateCoasterModal();
  }

  async function openCoasterModal(btn) {
    ensureCoasterCss();
    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    const modal = getCoasterModal();
    if (!modal) return;

    coasterState.pendingBtn = btn;
    coasterState.grid1 = [];
    coasterState.grid2 = [];

    try {
      const resp = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`);
      if (!resp.ok) throw new Error('Product fetch failed');
      coasterState.product = await resp.json();
      renderCoasterGrids(coasterState.product);
      modal.hidden = false;
      document.body.classList.add('overflow-hidden');
      modal.querySelector('[data-ewa-coaster-save]')?.focus();
    } catch {
      /* silent — no modal */
    }
  }

  function saveCoasterPairs() {
    const product = coasterState.product;
    const btn = coasterState.pendingBtn;
    if (!product || !btn) return;

    const g1 = coasterState.grid1;
    const g2 = coasterState.grid2;
    if (!g1.length || g1.length !== g2.length) return;

    g1.forEach((c1, i) => {
      const properties = { 'Pattern 2': g2[i].code };
      EwaFavorites.add({
        productId: product.id,
        productHandle: product.handle,
        variantId: c1.variantId,
        properties,
      });
    });

    closeCoasterModal();
  }

  function bindCoasterModal() {
    const modal = getCoasterModal();
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = 'true';

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-ewa-coaster-close]')) {
        closeCoasterModal();
        return;
      }
      const swatch = event.target.closest('.aycan-swatch-item');
      if (swatch && modal.contains(swatch)) {
        event.preventDefault();
        toggleCoasterSwatch(swatch);
        return;
      }
      if (event.target === modal.querySelector('.ewa-fav-coaster-modal__backdrop')) {
        closeCoasterModal();
      }
    });

    modal.querySelector('[data-ewa-coaster-save]')?.addEventListener('click', () => saveCoasterPairs());

    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape' && !getCoasterModal()?.hidden) {
        closeCoasterModal();
      }
    });
  }

  function itemFromButton(btn) {
    return {
      productId: btn.getAttribute('data-product-id'),
      productHandle: btn.getAttribute('data-product-handle'),
      variantId: btn.getAttribute('data-variant-id'),
      properties: {},
      propertiesHash: btn.getAttribute('data-properties-hash') || '',
    };
  }

  function handleFavoriteClick(event) {
    const btn = event.target.closest('[data-ewa-favorite]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    if (btn.getAttribute('data-requires-coaster-pick') === 'true') {
      openCoasterModal(btn);
      return;
    }

    EwaFavorites.toggle(itemFromButton(btn));
  }

  function bindVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const variant = data?.variant;
      if (!variant) return;
      document.querySelectorAll('.ewa-card__fav--buybox[data-ewa-favorite]').forEach((btn) => {
        btn.setAttribute('data-variant-id', variant.id);
      });
      EwaFavorites.syncDom();
    });
  }

  /* ── Favorites page render ───────────────────────────── */
  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  async function renderFavoritesPage() {
    const root = document.getElementById('ewa-favorites-root');
    if (!root) return;

    const grid = root.querySelector('[data-ewa-favorites-grid]');
    const empty = root.querySelector('[data-ewa-favorites-empty]');
    const items = EwaFavorites.getAll();

    if (!items.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      updateHeaderCount(0);
      return;
    }

    if (empty) empty.hidden = true;
    if (!grid) return;

    grid.innerHTML = '<p class="ewa-favorites-loading caption">Loading…</p>';

    const cards = await Promise.all(
      items.map(async (item) => {
        try {
          const resp = await fetch(`${window.Shopify?.routes?.root || '/'}products/${item.productHandle}.js`);
          if (!resp.ok) return null;
          const product = await resp.json();
          const variant = product.variants.find((v) => String(v.id) === String(item.variantId));
          return { item, product, variant };
        } catch {
          return null;
        }
      })
    );

    const validCards = cards.filter(Boolean);
    grid.innerHTML = validCards
      .map(({ item, product, variant }) => {
        const unavailable = !variant || !variant.available;
        const img =
          variant?.featured_image?.src ||
          product.featured_image ||
          product.images?.[0] ||
          '';
        const propsLabel = item.properties?.['Pattern 2']
          ? `${variant?.title || product.title} · ${item.properties['Pattern 2']}`
          : variant?.title && variant.title !== 'Default Title'
            ? variant.title
            : '';
        const price = variant ? formatMoney(variant.price) : '';
        const hash = item.propertiesHash || propertiesHash(item.properties);

        return `
          <li class="grid__item">
            <article class="ewa-favorite-card ewa-card${unavailable ? ' ewa-favorite-card--unavailable' : ''}" data-variant-id="${item.variantId}" data-properties-hash="${hash}">
              <a href="/products/${product.handle}" class="ewa-favorite-card__media">
                ${img ? `<img src="${img}" alt="${escapeHtml(product.title)}" loading="lazy" width="600" height="600">` : ''}
                ${unavailable ? `<span class="ewa-favorite-card__badge">${strings.unavailable || 'No longer available'}</span>` : ''}
              </a>
              <div class="ewa-favorite-card__body">
                <a href="/products/${product.handle}" class="ewa-favorite-card__title">${escapeHtml(product.title)}</a>
                ${propsLabel ? `<p class="ewa-favorite-card__variant">${escapeHtml(propsLabel)}</p>` : ''}
                ${price ? `<p class="ewa-favorite-card__price">${price}</p>` : ''}
                <button type="button" class="ewa-favorite-card__atc button button--primary button--full-width" data-ewa-favorite-atc data-variant-id="${item.variantId}" ${unavailable ? 'disabled' : ''}>
                  ${strings.addToCart || 'Add to cart'}
                </button>
                <button type="button" class="ewa-favorite-card__remove aycan-slide-underline" data-ewa-favorite-remove data-variant-id="${item.variantId}" data-properties-hash="${hash}">
                  ${strings.remove || 'Remove'}
                </button>
              </div>
            </article>
          </li>`;
      })
      .join('');

    updateHeaderCount(items.length);
    EwaFavorites.syncDom();
  }

  async function addFavoriteToCart(btn) {
    const card = btn.closest('.ewa-favorite-card');
    if (!card || btn.disabled) return;

    const variantId = btn.getAttribute('data-variant-id');
    const hash = card.getAttribute('data-properties-hash') || '';
    const item = EwaFavorites.getAll().find((f) => itemKey(f) === `${variantId}::${hash}`);
    if (!item) return;

    const body = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          ...(item.properties && Object.keys(item.properties).length ? { properties: item.properties } : {}),
        },
      ],
    };

    const drawer = document.querySelector('cart-drawer');
    if (drawer?.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    btn.classList.add('is-loading');
    try {
      const resp = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.description);
      if (drawer?.renderContents) {
        drawer.renderContents(data);
        drawer.open?.();
      }
    } catch {
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } finally {
      btn.classList.remove('is-loading');
    }
  }

  function init() {
    bindCoasterModal();
    bindVariantSync();
    EwaFavorites.syncDom();
    updateHeaderCount(EwaFavorites.count());
    renderFavoritesPage();

    document.addEventListener('click', handleFavoriteClick);

    document.addEventListener('click', (event) => {
      const removeBtn = event.target.closest('[data-ewa-favorite-remove]');
      if (removeBtn) {
        event.preventDefault();
        EwaFavorites.remove(removeBtn.getAttribute('data-variant-id'), removeBtn.getAttribute('data-properties-hash') || '');
        renderFavoritesPage();
        return;
      }

      const atcBtn = event.target.closest('[data-ewa-favorite-atc]');
      if (atcBtn) {
        event.preventDefault();
        addFavoriteToCart(atcBtn);
      }
    });

    document.addEventListener('ewa:favorites-updated', () => {
      if (document.getElementById('ewa-favorites-root')) {
        renderFavoritesPage();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
